/* eslint-disable default-param-last */
import {
  REVIEW_AND_SUBMIT_BTN_SUBMIT_PRESS,
  REVIEW_AND_SUBMIT_CONFIG,
  REVIEW_AND_SUBMIT_ERROR,
  REVIEW_AND_SUBMIT_LOADING,
  REVIEW_AND_SUBMIT_STEP_1_DATA,
  SET_REVIEW_AND_SUBMIT_BTN_DISPLAY,
} from '../types';

const INITIAL_STATE = {
  shouldShowReviewAndSubmitButton: false,
  primaryCertifier: true,
  primaryCertifierName: '',
  withESignature: false,
  isCommentEnabled: false,
  enableloginSignature: '',
  noOfTries: '',
  userAttribute: '',
  step1Data: {},
  step2Data: {
    predefComments: [
      // '// WIP: Predefined option 1',
      // '// WIP: Predefined option 2',
      // '// WIP: Predefined option 3',
    ],
  },
  isLoadingReviewAndSubmit: true,
  isSubmittingReviewAndSubmit: false,
  reviewAndSubmitError: false,
};

const reviewAndSubmitReducer = (state = INITIAL_STATE, action) => {
  switch (action?.type) {
    case SET_REVIEW_AND_SUBMIT_BTN_DISPLAY:
      return {
        ...state,
        shouldShowReviewAndSubmitButton: action?.payload,
      };

    case REVIEW_AND_SUBMIT_LOADING:
      return {
        ...state,
        isLoadingReviewAndSubmit: action?.payload,
      };

    case REVIEW_AND_SUBMIT_BTN_SUBMIT_PRESS:
      return {
        ...state,
        isSubmittingReviewAndSubmit: action?.payload,
      };

    case REVIEW_AND_SUBMIT_ERROR:
      return {
        ...state,
        reviewAndSubmitError: action?.payload?.isError,
        error: action?.payload?.error,
      };

    case REVIEW_AND_SUBMIT_CONFIG:
      return {
        ...state,
        ...action?.payload,
      };

    case REVIEW_AND_SUBMIT_STEP_1_DATA:
      return {
        ...state,
        step1Data: {
          ...state.step1Data,
          ...action?.payload?.results,
        },
      };

    default:
      return state;
  }
};

export default reviewAndSubmitReducer;
